// @ts-nocheck
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('[data-location-map]')) return;

  const mapEl = document.getElementById('leaflet-map');
  if (!mapEl) return;

  const markerEls = document.querySelectorAll('.map-marker');
  if (!markerEls.length) return;

  let mapInstance;
  let activeLayer;

  /* -----------------------------------------
   * Build marker objects from DOM
   * ----------------------------------------- */
  const markers = Array.from(markerEls).map(el => {
    const lat = parseFloat(el.dataset.lat);
    const lon = parseFloat(el.dataset.lng || el.dataset.lon);

    return {
      name: el.dataset.name || '',
      url: el.dataset.url || '',
      image: el.dataset.image || '',
      rating: el.dataset.rating || '',
      reviews: el.dataset.reviews || '',

      lat: Number.isFinite(lat) ? lat : null,
      lon: Number.isFinite(lon) ? lon : null,
      street: el.dataset.street || '',
      city: el.dataset.city || '',
      region: el.dataset.region || '',
      country: el.dataset.country || '',
      title: el.dataset.title || ''
    };
  });

  /* -----------------------------------------
   * Cache helpers
   * ----------------------------------------- */
  function getCachedLocation(query) {
    const cached = localStorage.getItem(`geo_${query}`);
    if (!cached) return null;

    try {
      const parsed = JSON.parse(cached);
      if (!parsed.ts || Date.now() - parsed.ts > 86400000) {
        localStorage.removeItem(`geo_${query}`);
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  }

  function setCachedLocation(query, data) {
    localStorage.setItem(
      `geo_${query}`,
      JSON.stringify({ ...data, ts: Date.now() })
    );
  }

  /* -----------------------------------------
   * Geocoding
   * ----------------------------------------- */
  async function fetchLocation(query) {
    const cached = getCachedLocation(query);
    if (cached) return cached;

    const url =
      'https://nominatim.openstreetmap.org/search?' +
      new URLSearchParams({
        format: 'json',
        q: query,
        limit: 1
      });

    const res = await fetch(url);
    const data = await res.json();

    if (!data || !data.length) return null;

    const result = {
      lat: parseFloat(data[0].lat),
      lon: parseFloat(data[0].lon)
    };

    setCachedLocation(query, result);
    return result;
  }

  /* -----------------------------------------
   * Resolve marker locations
   * ----------------------------------------- */
  async function resolveMarkers() {
    const resolved = [];

    for (const m of markers) {
      // Direct coordinates
      if (Number.isFinite(m.lat) && Number.isFinite(m.lon)) {
        resolved.push(m);
        continue;
      }

      const queries = [
        [m.street, m.city, m.region, m.country],
        [m.city, m.region, m.country],
        [m.region, m.country],
        [m.country]
      ]
        .map(p => p.filter(Boolean).join(', '))
        .filter(Boolean);

      for (const query of queries) {
        const geo = await fetchLocation(query);
        if (geo) {
          resolved.push({ ...m, lat: geo.lat, lon: geo.lon });
          break;
        }
      }
    }

    return resolved;
  }

  /* -----------------------------------------
   * Popup HTML
   * ----------------------------------------- */
  function buildPopup(loc) {
    return `
      <a href="${loc.url}" target="_blank" class="map-popup-link" aria-label="${loc.name}">
        <div class="tooltip-container relative m-0! p-0! w-[300px] h-[200px] rounded-2xl overflow-hidden">
          ${loc.image ? `<img class="tooltip-image" src="${loc.image}" />` : ''}
          <div class="tooltip-bottom">
            <div class="tooltip-rating">
              <p class="m-0! p-0!">${loc.rating ? `${loc.rating}` : '0'} <span>★</span></p>
              <p class="m-0! p-0!">${loc.reviews ? `${loc.reviews}` : '0'} Reviews</p>
            </div>
            <h1 class="capitalize font-inter! text-lg!">${loc.name}</h1>
          </div>
        </div>
      </a>
    `;
  }

  /* -----------------------------------------
   * Init map
   * ----------------------------------------- */
  function initMap(resolvedMarkers) {
    let firstLeafletMarker = null;
    if (!resolvedMarkers.length) return;

    mapInstance = L.map('leaflet-map', {
      zoomControl: false
    });

    const street = L.tileLayer(
      'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        attribution: '&copy; OpenStreetMap contributors',
        minZoom: 8
      }
    );

    const satellite = L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      {
        attribution: '&copy; Esri',
        minZoom: 8
      }
    );

    street.addTo(mapInstance);
    activeLayer = street;

    document.querySelectorAll('.map-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        mapInstance.removeLayer(activeLayer);
        activeLayer =
          btn.dataset.layer === 'satellite' ? satellite : street;
        activeLayer.addTo(mapInstance);

        document
          .querySelectorAll('.map-btn')
          .forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });

    L.control.zoom({ position: 'bottomright' }).addTo(mapInstance);

    const bounds = [];

    const customIcon = L.icon({
      iconUrl: window.MAP_MARKER_URL,
      iconSize: [24, 40],
      iconAnchor: [12, 20]
    });

    resolvedMarkers.forEach((m, index) => {
      const leafletMarker = L.marker([m.lat, m.lon], { icon: customIcon })
        .addTo(mapInstance)
        .bindPopup(buildPopup(m), {
          closeButton: false,
          maxWidth: 320
        });

      if (index === 0) {
        firstLeafletMarker = leafletMarker;
      }

      bounds.push([m.lat, m.lon]);
    });

    if (firstLeafletMarker) {
      const firstLatLng = firstLeafletMarker.getLatLng();

      mapInstance.setView(firstLatLng, 10);

      // Open popup after map is fully ready
      setTimeout(() => {
        firstLeafletMarker.openPopup();
      }, 300);
    }

    setTimeout(() => mapInstance.invalidateSize(), 200);
  }

  /* -----------------------------------------
   * Start
   * ----------------------------------------- */
  resolveMarkers().then(initMap);
});